import {IComponentOptions} from 'angular';
import {getTSAnredeValues, TSAnrede} from '../../../models/enums/TSAnrede';
import {getLanguageByKey, getTSSpracheValues, TSSprache} from '../../../models/enums/TSSprache';
import TSGesuchsPerson from '../../../models/TSGesuchsPerson';

declare let require: any;
declare let angular: any;
import ITranslateService = angular.translate.ITranslateService;

export class KontaktPersonComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        name: '@',
        dontShowAdresse: '<',
        dontShowKorrespondenzsprache: '<',
        emailNotRequired: '<?',
        dontShowEmail: '<?',
        phoneRequired: '<?',
        angabe: '@',

    };
    template = require('./dv-kontakt-person.html');
    controller = DvKontaktPersonController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvKontaktPersonController {

    model?: TSGesuchsPerson;
    name: string;
    angabe: string;
    dontShowAdresse: boolean;
    dontShowKorrespondenzsprache: boolean;
    emailNotRequired: boolean;
    dontShowEmail: boolean;
    phoneRequired: boolean;

    static $inject: any[] = ['CONSTANTS', '$translate'];

    /* @ngInject */
    constructor(private CONSTANTS: any, private $translate: ITranslateService) {

    }

    $onInit() {
        let tmpmodel: any = this.getModel();
        if (tmpmodel) {
            tmpmodel.gesuchsPersonDatenFS.korrespondenzsprache = getLanguageByKey(this.getCurrentLang());
        }
        tmpmodel = null;
    }

    public getModel(): TSGesuchsPerson | undefined {
        return this.model;
    }

    private getTSAnredeValues(): Array<TSAnrede> {
        return getTSAnredeValues();
    }

    private getTSSpracheValues(): Array<TSSprache> {
        return getTSSpracheValues();
    }

    public getCurrentLang(): string {
        return this.$translate.use();
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-kontakt-person/dv-kontakt-person.ts